import {
  applyBidHiddenCube,
  applyDecideHiddenCube,
  applyPassHiddenCubeBid,
  applyRejectCube,
  applyTakeCube,
  applyTransferGarnet,
} from "./appliers";
import type { MinusAuctionAction, MinusAuctionState } from "./types";
import { validateAction } from "./validators";

export function reduceGameState(
  state: MinusAuctionState,
  action: MinusAuctionAction,
): MinusAuctionState {
  if (!validateAction(state, action).valid) {
    return state;
  }

  if (action.type === "RejectCube") {
    return applyRejectCube(state, action);
  }
  if (action.type === "TakeCube") {
    return applyTakeCube(state, action);
  }
  if (action.type === "TransferGarnet") {
    return applyTransferGarnet(state, action);
  }
  if (action.type === "BidHiddenCube") {
    return applyBidHiddenCube(state, action);
  }
  if (action.type === "PassHiddenCubeBid") {
    return applyPassHiddenCubeBid(state, action);
  }
  if (action.type === "DecideHiddenCube") {
    return applyDecideHiddenCube(state, action);
  }

  return state;
}
